export class Login {
  login: string;
  password: string;
}


// WEBPACK FOOTER //
// ./src/app/models/login.ts